import { render, staticRenderFns } from "./cooking-inputs.vue?vue&type=template&id=2f72b26e&"
import script from "./cooking-inputs.vue?vue&type=script&lang=js&"
export * from "./cooking-inputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports